import React from 'react'
import './homework-assign.scss'
import { Constants, ImageConstants } from '../../constants/constants'
import { getImageSource } from '../../utility/image-source'
import Loading from '../common/loading/loading'
import Urls from '../../apis/url'
import httpClient from '../../apis/http-client'
import ToasterComponent from '../common/cw-toaster-component/cw-toaster-component'
import { Link } from 'react-router-dom'
import Path from '../routes/routes-path'
import moment from 'moment'
import HomeworkApi from '../../apis/homework'

class HomeworkAssign extends React.Component {
  state = {
    loading: true,
    homeworkDetails: {
      count: 0
    }
  }

  constructor(props) {
    super(props)


    let urlParams = new URLSearchParams(window.location.search);


    this.schoolId = urlParams.get('schoolId')
    this.eventId = urlParams.get('eventId')

    if (!this.schoolId) {
      this.state.schoolCode = props.match.params.code
      this.state.eventId = props.match.params.eventId
      this.state.className = this.getParameterByName('class', props.location?.search)
    }
  }

  /**
   * Get respective params from the provided URL
   * @param {*} name - Param name
   * @param {*} url - Provided URL
   */
  getParameterByName = (name, url) => {
    if (url) {
      name = name.replace(/[\[\]]/g, '\\$&')
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    }

    return ''
  }

  componentDidMount() {
    console.log(this.schoolId)
    if (!this.schoolId) {
      this.assignEventHomework()
    } else {
      this.assignEventHomeworkV2()
    }
  }

  assignEventHomework() {
    const { schoolCode, eventId, className } = this.state
    let payload = {
      schoolId: schoolCode,
      eventId: eventId
    }
    if (className && className !== 'all') {
      payload.class = className.replace('-', '')
    }

    HomeworkApi.assignHomeworkV3(payload)
      .then(response => {

        let classList = [], studentCount = 0

        if (response.homeworkAlreadyCreatedRespose && response.homeworkAlreadyCreatedRespose.length) {

          for (let i = 0; i < response.homeworkAlreadyCreatedRespose.length; i++) {
            let alreadyCreatedHomework = response.homeworkAlreadyCreatedRespose[i]

            classList.push(alreadyCreatedHomework.class)
            studentCount += alreadyCreatedHomework.count
          }

          this.setState({
            loading: false,
            alreadyAssigned: true,
            homeworkDetails: { classList, studentCount }
          })

        }

        let homeworkAssignedClassList = [], homeworkAssignedStudentCount = 0

        if (response.responsePayload && response.responsePayload.count) {
          this.setState({
            loading: false,
            homeworkAssignSuccess: true,
            homeworkAssigedDetails: {
              homeworkAssignedStudentCount: response.responsePayload.count,
              link: response.responsePayload.link,
              dueDate: response.responsePayload.dueDate,
              schoolName: response.responsePayload.schoolName,
              classes: response.responsePayload.classes
            },
            
          })
        }



        // if (response.code == 11000) {
        //   this.setState({
        //     loading: false,
        //     alreadyAssigned: true,
        //     homeworkDetails: response || {}
        //   })
        // } else {
        //   this.setState({
        //     loading: false,
        //     homeworkAssignSuccess: true,
        //     homeworkDetails: response || {}
        //   })
        // }
      }).catch(err => {
        this.showToaster('error', 'Something went wrong. Contact support')
        this.setState({
          error: true
        })
      })

  }

  assignEventHomeworkV2() {
    let payload = {
      schoolId: this.schoolId,
      eventId : this.eventId
    }

    HomeworkApi.assignHomeworkV2(payload)
      .then(response => {

        let classList = [], studentCount = 0

        if (response.homeworkAlreadyCreatedRespose && response.homeworkAlreadyCreatedRespose.length) {

          for (let i = 0; i < response.homeworkAlreadyCreatedRespose.length; i++) {
            let alreadyCreatedHomework = response.homeworkAlreadyCreatedRespose[i]

            classList.push(alreadyCreatedHomework.class)
            studentCount += alreadyCreatedHomework.count
          }

          this.setState({
            loading: false,
            alreadyAssigned: true,
            homeworkDetails: { classList, studentCount }
          })

        }

        let homeworkAssignedClassList = [], homeworkAssignedStudentCount = 0

        if (response.responsePayload && response.responsePayload.count) {
          this.setState({
            loading: false,
            homeworkAssignSuccess: true,
            homeworkAssigedDetails: {
              homeworkAssignedStudentCount: response.responsePayload.count,
              link: response.responsePayload.link,
              dueDate: response.responsePayload.dueDate,
              schoolName: response.responsePayload.schoolName,
              classes: response.responsePayload.classes
            },
            
          })
        }

        // if (response.code == 11000) {
        //   this.setState({
        //     loading: false,
        //     alreadyAssigned: true,
        //     homeworkDetails: response || {}
        //   })
        // } else {
        //   this.setState({
        //     loading: false,
        //     homeworkAssignSuccess: true,
        //     homeworkDetails: response || {}
        //   })
        // }
      }).catch(err => {
        this.showToaster('error', 'Something went wrong. Contact support')
        this.setState({
          error: true
        })
      })

  }
  convertDate = (date, currentFormat = '', requiredFormat = 'DD MMM YYYY') => {
    return moment(date, currentFormat).format(requiredFormat)
  }

  copyLink = _ => {
    const { homeworkAssigedDetails } = this.state
    var dummy = document.createElement('textarea')
    // dummy.style.display = 'none'
    document.body.appendChild(dummy)

    dummy.value = `Dear Students,

    A New Primer Course has been created for you by ${homeworkAssigedDetails.schoolName}, to be completed on the Countingwell App.
    
    Assignment Name: Primer Course 
    Due Date: ${this.convertDate(new Date(homeworkAssigedDetails.dueDate))}
    
    You must complete the assignment before this due date.
    
    To view and start the assignment, go to this link: ${homeworkAssigedDetails.link}
    
    All the best`
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
    this.showToaster('info', 'Copied')
  }

  showToaster(type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  hideToaster() {
    this.setState({
      showToaster: false
    })
  }

  render() {
    const {
      toasterMessage,
      toasterType,
      showToaster,
      homeworkDetails,
      homeworkAssigedDetails,
      alreadyAssigned
    } = this.state
    return (
      <>
        <div className='container-fluid homework-success'>
          <div className='loader'>
            {this.state.loading && <Loading />}
          </div>
          <div className='row no-gutters'>
            <div className='col-12 p-2 py-3'>
              <img alt='cw-logo' src={getImageSource(ImageConstants.CW_LOGO)} />
            </div>
          </div>
          {!this.state.loading && (
            <div className='row mt-2'>
              <div className='col-lg-6'>
                <div className='homework-success-left'>
                  <img
                    src={getImageSource(ImageConstants.HOMEWORK_SUCCESS_LEFT)}
                  />
                  <div className='homework-success-left-content'>

                    {
                      alreadyAssigned ? <div>
                        Homework {alreadyAssigned ? "already" : ""} assigned to <strong>{homeworkDetails.studentCount}{' '}
                          students</strong> {homeworkDetails.classList.length === 1 ? <> of <strong>{homeworkDetails.classList.join(', ')}</strong>.</> : <>.</>} <Link className="click-here" to={Path.STANDARD_HOMEWORK}>Click here</Link> to view the list.
                      </div> : <></>
                    }

                    {this.state.homeworkAssignSuccess && (
                      <>
                        <div>
                          Homework assigned to <strong>{homeworkAssigedDetails.homeworkAssignedStudentCount}{' '}
                            students</strong> {homeworkAssigedDetails.classes.length === 1 ? <>of <strong>{homeworkAssigedDetails.classes.join(', ')}</strong>.</>: <>.</>}
                            <Link className="click-here" to={Path.STANDARD_HOMEWORK}>Click here</Link> to view the list.
                        </div>
                        <div className='share-title'>
                          Copy this link and share with students to assign them the homework
                        </div>
                        <div className='share-link cursor-pointer' title="Copy Link" onClick={this.copyLink}>
                          {homeworkAssigedDetails.link}
                        </div>
                        <div>
                          <button
                            className={`cw-button-homework`}
                            onClick={this.copyLink}
                          >
                            COPY LINK
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className='col-lg-6'>
                <div className='homework-success-right'>
                  <img
                    src={getImageSource(ImageConstants.HOMEWORK_SUCCESS_RIGHT)}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        {showToaster ? (
          <div className='custom-toaster-modal'>
            <ToasterComponent
              message={toasterMessage}
              type={toasterType}
              position='bottom-center'
            />
          </div>
        ) : (
          ''
        )}
      </>
    )
  }
}

export default HomeworkAssign
